module.exports = require('./blockly_compressed_vertical').goog;



//////////////////
// WEBPACK FOOTER
// ./~/scratch-blocks/shim/blockly_compressed_vertical.goog.js
// module id = 30
// module chunks = 0